// extracted by mini-css-extract-plugin
module.exports = {"zuzLogo":"GuestUserHeader_zuzLogo__z3VNA","verifiedUserStatusPre":"GuestUserHeader_verifiedUserStatusPre__3w3PH"};